import React from 'react'
import Map from './Map'
import PinWrapper from './PinWrapper'
import Icon from '../../packages/kiti/components/shapes/Icon'
import { COLORS } from '@btime/constants'

const CoordinatesMap = ({ value }) => {
  const [zoom, setZoom] = React.useState(15)

  return (
    <Map
      defaultCenter={{ lat: value?.latitude, lng: value?.longitude }}
      zoom={zoom}
      enableStreetView
      _yesIWantToUseGoogleMapApiInternals
      onChange={event => setZoom(event.zoom)}
    >
      <PinWrapper lat={value.latitude} lng={value.longitude} onClick={() => setZoom(18)}>
        <Icon name="RiMapPin2Fill" size={3} color={COLORS.primary} />
      </PinWrapper>
    </Map>
  )
}

export default CoordinatesMap
